import { useEffect, useState } from 'react';
import { getVersion } from '../api/health';
import { APP_VERSION } from '../lib/version';

/**
 * Systemversionen til topbaren (kontrakt 0.3.2). Hentes én gang fra
 * GET /api/version, naar skallen monteres (dvs. efter login). Fejler kaldet,
 * beholdes build-versionen fra package.json, saa topbaren aldrig staar tom.
 */
export function useSystemVersion(): string {
  const [version, setVersion] = useState(APP_VERSION);

  useEffect(() => {
    const controller = new AbortController();
    getVersion(controller.signal)
      .then((response) => {
        if (response?.system_version) setVersion(response.system_version);
      })
      .catch(() => {
        /* beholder build-versionen */
      });
    return () => controller.abort();
  }, []);

  return version;
}
